import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SyncSource, SyncSourceCreateRequest } from '../core/sync-source';
import { SyncConfig } from '../core/api-config';
import { CoursePagedResult } from '../core/common/CoursePagedResult';
import { XCourseFilter } from '../core/common/XCourseFilter';


@Injectable({
    providedIn: 'root'
})
export class ApiService {
    // Base API URL
    private readonly baseUrl = SyncConfig.syncUrl;

    constructor(private http: HttpClient) { }

    /// <summary>
    /// Get all configured sync sources.
    /// </summary>
    /* getSources(): Observable<SyncSource[]> {
        return this.http.get<SyncSource[]>(`${this.baseUrl}/api/sync-sources`);
    } */
   
getSources(searchKey: string = ''): Observable<SyncSource[]> {
    return this.http.get<SyncSource[]>(
        `${this.baseUrl}/api/sync-sources`,
        {
            params: {
                searchKey: searchKey.trim()
            }
        }
    );
}

getAllSourcesList(
  filter: XCourseFilter
): Observable<CoursePagedResult<SyncSource>> {

  let params = new HttpParams()
    .set('action', filter.action || '')
    .set('type', filter.type || '')
    .set('search', filter.search || '')
    .set('searchKey', filter.searchKey || '')
    .set('stateCode', filter.stateCode || '')
    .set('currentPage', String(filter.currentPage || 1));

  if (filter.pageSize != null) {
    params = params.set(
      'pageSize',
      String(filter.pageSize)
    );
  }

  if (filter.isActive !== null && filter.isActive !== undefined) {
    params = params.set(
      'isActive',
      String(filter.isActive)
    );
  }

  return this.http.get<CoursePagedResult<SyncSource>>(
    `${this.baseUrl}/api/sync-sources/GetSyncSourceList`,
    { params }
  );
}







    /// <summary>
    /// Add one or more sync sources.
    /// </summary>
    addSources(items: SyncSourceCreateRequest[]): Observable<SyncSource[]> {
        return this.http.post<SyncSource[]>(
            `${this.baseUrl}/api/sync-sources/bulk`,
            { items }
        );
    }

    /// <summary>
    /// Update an existing sync source.
    /// </summary>
    updateSource(id: number, source: SyncSource): Observable<object> {
        return this.http.put(
            `${this.baseUrl}/api/sync-sources/${id}`,
            source
        );
    }

    /// <summary>
    /// Enable or disable a sync source.
    /// </summary>
    setActive(id: number, active: boolean): Observable<object> {
        return this.http.patch(
            `${this.baseUrl}/api/sync-sources/${id}/active/${active}`,
            {}
        );
    }

    /// <summary>
    /// Delete a configured sync source.
    /// </summary>
    delete(id: number): Observable<object> {
        return this.http.delete(`${this.baseUrl}/api/sync-sources/${id}`);
    }

    /// <summary>
    /// Queue a single sync source.
    /// </summary>
    runOne(id: number): Observable<object> {
        return this.http.post(`${this.baseUrl}/api/sync-jobs/run/${id}`, {});
    }

    /// <summary>
    /// Queue selected sync sources first.
    /// </summary>
    runSelected(sourceIds: number[]): Observable<object> {
        return this.http.post(
            `${this.baseUrl}/api/sync-jobs/run-selected`,
            { sourceIds }
        );
    }

    /// <summary>
    /// Queue all active sync sources.
    /// </summary>
    runAll(): Observable<object> {
        return this.http.post(`${this.baseUrl}/api/sync-jobs/run-all`, {});
    }
}
